export const reportJunk = "sFtCVd";
export default {reportJunk};